import {
  getDatetime,
  getStringNoLocale,
  setDatetime,
  setStringNoLocale,
  Thing,
  ThingLocal,
  ThingPersisted,
} from '@inrupt/solid-client'
import { DateTime } from 'luxon'
import { URI } from '../utils/ontology'
import { ThingFactory } from '../utils/ThingFactory'
import { checkType } from './utils'

/**
 * External owl:Class
 * http://purl.org/wf4ever/wfprov#ProcessRun
 */
export class ProcessRun {
  protected readonly _thing: ThingPersisted

  constructor(thing: ThingPersisted) {
    checkType(thing, URI.WORKFLOW_PROCESS_RUN_CLASS)
    this._thing = thing
  }

  get thing(): ThingPersisted {
    return this._thing
  }

  get startedAt(): Date | undefined {
    return (
      getDatetime(this.thing, URI.PROVENANCE_ACTIVITY_STARTED_AT) || undefined
    )
  }

  get endedAt(): Date | undefined {
    return (
      getDatetime(this.thing, URI.PROVENANCE_ACTIVITY_ENDED_AT) || undefined
    )
  }

  setStartedAt(date: Date): Thing {
    return setDatetime(this.thing, URI.PROVENANCE_ACTIVITY_STARTED_AT, date)
  }

  setEndedAt(date: Date): Thing {
    return setDatetime(this.thing, URI.PROVENANCE_ACTIVITY_ENDED_AT, date)
  }
}

export class SurveyCompletionTask extends ProcessRun {
  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_COMPLETION_TASK_CLASS)
    super(thing)
  }

  get sessionId(): string {
    return getStringNoLocale(this.thing, URI.SURVEY_SESSION_ID_PREDICATE) || ''
  }

  setSessionId(id: string): Thing {
    return setStringNoLocale(this.thing, URI.SURVEY_SESSION_ID_PREDICATE, id)
  }
}

export const createSurveyCompletionTask = (
  sessionId: string,
  startedAt: DateTime,
  endedAt: DateTime
): ThingLocal =>
  new ThingFactory()
    .addUrl(URI.TYPE_PREDICATE, URI.SURVEY_COMPLETION_TASK_CLASS)
    .addUrl(URI.TYPE_PREDICATE, URI.WORKFLOW_PROCESS_RUN_CLASS)
    .addStringNoLocale(URI.SURVEY_SESSION_ID_PREDICATE, sessionId)
    .addDatetime(URI.PROVENANCE_ACTIVITY_STARTED_AT, startedAt.toJSDate())
    .addDatetime(URI.PROVENANCE_ACTIVITY_ENDED_AT, endedAt.toJSDate())
    .build()
